export default "__VITE_ASSET__DFmlB8kc__"